import { supabase } from '../lib/supabase';

const SUPABASE_PROJECT_URL = process.env.REACT_APP_SUPABASE_URL;

export class CourseService {
  static async getAccessToken() {
    const { data: { session } } = await supabase.auth.getSession();
    return session?.access_token;
  }

  static async getAllCourses() {
    console.log('コース一覧取得中...');
    
    // コースデータを提供
    return {
      courses: [
        {
          id: 1,
          title: '生成AI Boost初級編',
          description: 'AIの基礎から学ぶ初心者向けコース',
          category: 'ai',
          level: '初級',
          duration: '4週間',
          lesson_count: 0,
          video_count: 0,
          enrolled_count: 0,
          rating: 4.8,
          instructor: 'CCHR講師',
          thumbnail_url: '/first.png',
          enrolled: false,
          progress: 0
        },
        {
          id: 2,
          title: '生成AI Boost中級編',
          description: 'AIの実践的な活用方法を学ぶ',
          category: 'ai',
          level: '中級',
          duration: '6週間',
          lesson_count: 0,
          video_count: 0,
          enrolled_count: 0,
          rating: 4.9,
          instructor: 'CCHR講師',
          thumbnail_url: '/second.png',
          enrolled: false,
          progress: 0
        },
        {
          id: 3,
          title: '生成AI Boost上級編',
          description: 'AIの高度な技術と応用を学ぶ',
          category: 'ai',
          level: '上級',
          duration: '8週間',
          lesson_count: 0,
          video_count: 0,
          enrolled_count: 0,
          rating: 4.7,
          instructor: 'CCHR講師',
          thumbnail_url: '/third.png',
          enrolled: false,
          progress: 0
        }
      ],
      categories: [
        { id: 'all', name: 'すべて', count: 3 },
        { id: 'ai', name: 'AI・機械学習', count: 3 }
      ]
    };
  }

  static async getCourseProgress() {
    console.log('コース進捗取得中（フォールバックデータ使用）...');
    
    // Phase 3: 進捗APIエンドポイントは未実装のため、フォールバックデータを使用
    return {
      coursesInProgress: [
        {
          id: 1,
          title: 'React Advanced Patterns',
          progress: 75,
          totalLessons: 24,
          completedLessons: 18,
          estimatedCompletion: '2024-03-15',
          category: 'Frontend',
          difficulty: 'Advanced',
          recentActivity: '2時間前'
        },
        {
          id: 2,
          title: 'Node.js Master Class',
          progress: 45,
          totalLessons: 32,
          completedLessons: 14,
          estimatedCompletion: '2024-03-25',
          category: 'Backend',
          difficulty: 'Intermediate',
          recentActivity: '1日前'
        }
      ],
      overallStats: {
        totalCourses: 15,
        completedCourses: 12,
        totalHours: 127,
        averageScore: 87
      },
      achievements: [
        {
          id: 1,
          title: 'JavaScript Master',
          description: '全てのJavaScriptコースを完了',
          icon: '🏆',
          earnedDate: '2024-02-15',
          rarity: 'gold'
        },
        {
          id: 2,
          title: '7日連続学習',
          description: '7日間連続で学習を継続',
          icon: '🎯',
          earnedDate: '2024-02-20',
          rarity: 'silver'
        }
      ],
      weeklyActivity: [
        { day: '月', hours: 2.5, lessons: 3 },
        { day: '火', hours: 1.8, lessons: 2 },
        { day: '水', hours: 3.2, lessons: 4 },
        { day: '木', hours: 2.1, lessons: 3 },
        { day: '金', hours: 1.5, lessons: 2 },
        { day: '土', hours: 4.0, lessons: 5 },
        { day: '日', hours: 2.8, lessons: 3 }
      ]
    };
  }

  static async getLearningStats() {
    console.log('学習統計取得中（フォールバックデータ使用）...');
    
    // Phase 3: 学習統計APIエンドポイントは未実装のため、フォールバックデータを使用
    return {
      inProgress: 3,
      completed: 12,
      totalHours: 127
    };
  }

  static async enrollCourse(courseId) {
    console.log(`コース受講開始処理（コースID: ${courseId}）...`);
    
    // Phase 3: 受講開始APIエンドポイントは未実装のため、成功レスポンスを模擬
    return { success: true, message: 'コースの受講を開始しました' };
  }

  static getLevelColor(level) {
    switch (level) {
      case '初級': return '#00b894';
      case '中級': return '#fdcb6e';
      case '上級': return '#e17055';
      default: return '#636e72';
    }
  }

  static getProgressColor(progress) {
    if (progress >= 80) return '#00b894';
    if (progress >= 60) return '#fdcb6e';
    if (progress >= 40) return '#e17055';
    return '#636e72';
  }

  static getRarityColor(rarity) {
    switch (rarity) {
      case 'gold': return '#f39c12';
      case 'silver': return '#95a5a6';
      case 'bronze': return '#d35400';
      default: return '#636e72';
    }
  }

  static async getAllVideos() {
    console.log('動画一覧取得中（フォールバックデータ使用）...');
    
    return {
      videos: [
        {
          id: '64YkJcWh8ns',
          youtube_id: '64YkJcWh8ns',
          title: '生成AI Boost初級編',
          description: '全13回の導入として「なぜ今生成AIなのか？」を市場の状況を踏まえ、AIスキルを身につけることでどんな変化、メリットがあるのかを解説していきます。',
          duration: '47:32',
          formatted_duration: '47:32',
          thumbnail_url: '/video-icon.png',
          video_url: 'https://youtu.be/64YkJcWh8ns?si=YaOukmLbGvijGSXe',
          course_id: 1,
          course_title: '生成AI Boost初級編',
          category: 'ai',
          level: '初級',
          view_count: 1250,
          upload_date: '2024-01-15',
          created_at: '2024-01-15T00:00:00Z',
          instructor: 'CCHR講師',
          tags: ['生成AI', '初級'],
          agenda: [
            { time: '00:00', title: 'はじめに' },
            { time: '05:30', title: '生成AIとは何か' },
            { time: '15:20', title: '活用事例' },
            { time: '35:10', title: 'まとめ' }
          ]
        },
        {
          id: '52VJJMYYkMA',
          youtube_id: '52VJJMYYkMA',
          title: '生成AI Boost中級編',
          description: '生成AIの基礎から学ぶ中級者向けコース',
          duration: '38:15',
          formatted_duration: '38:15',
          thumbnail_url: '/video-icon.png',
          video_url: 'https://youtu.be/52VJJMYYkMA?si=YaOukmLbGvijGSXe',
          course_id: 1,
          course_title: '生成AI Boost初級編',
          category: 'ai',
          level: '中級',
          view_count: 980,
          upload_date: '2024-01-20',
          created_at: '2024-01-20T00:00:00Z',
          instructor: 'CCHR講師',
          tags: ['生成AI', '中級'],
          agenda: [
            { time: '00:00', title: '中級編の概要' },
            { time: '08:30', title: '実践的な活用方法' },
            { time: '25:10', title: 'ケーススタディ' }
          ]
        },
        {
          id: 'kk7GlxWZAfk',
          youtube_id: 'kk7GlxWZAfk',
          title: '生成AI Boost上級編',
          description: '生成AIの応用技術を学ぶ上級者向けコース',
          duration: '52:48',
          formatted_duration: '52:48',
          thumbnail_url: '/video-icon.png',
          video_url: 'https://youtu.be/kk7GlxWZAfk?si=YaOukmLbGvijGSXe',
          course_id: 1,
          course_title: '生成AI Boost初級編',
          category: 'ai',
          level: '上級',
          view_count: 750,
          upload_date: '2024-01-25',
          created_at: '2024-01-25T00:00:00Z',
          instructor: 'CCHR講師',
          tags: ['生成AI', '上級'],
          agenda: [
            { time: '00:00', title: '上級編の紹介' },
            { time: '10:15', title: '高度な技術論' },
            { time: '30:20', title: '実装と応用' },
            { time: '45:30', title: '今後の展望' }
          ]
        }
      ],
      totalCount: 3,
      categories: [
        { id: 'all', name: 'すべて', count: 3 },
        { id: 'ai', name: 'AI・機械学習', count: 3 }
      ],
      levels: [
        { id: 'all', name: 'すべて', count: 3 },
        { id: '初級', name: '初級', count: 3 }
      ]
    };
  }

  static async getVideoById(videoId) {
    console.log(`動画詳細取得中（ID: ${videoId}）...`);
    
    const { videos } = await this.getAllVideos();
    const video = videos.find(v => v.id === videoId);
    
    if (!video) {
      throw new Error('動画が見つかりません');
    }
    
    return {
      ...video,
      related_videos: videos.filter(v => v.id !== videoId && v.course_id === video.course_id).slice(0, 3)
    };
  }

  static async getVideosByCourse(courseId) {
    console.log(`コース動画取得中（コースID: ${courseId}）...`);
    
    const { videos } = await this.getAllVideos();
    return {
      videos: videos.filter(v => v.course_id === parseInt(courseId)),
      courseTitle: videos.find(v => v.course_id === parseInt(courseId))?.course_title || ''
    };
  }

  static formatDuration(duration) {
    if (!duration) return '0:00';
    const parts = duration.split(':');
    if (parts.length === 2) {
      return `${parseInt(parts[0])}:${parts[1]}`;
    }
    return duration;
  }

  static formatViewCount(count) {
    if (count >= 1000000) {
      return `${(count / 1000000).toFixed(1)}M`;
    } else if (count >= 1000) {
      return `${(count / 1000).toFixed(1)}K`;
    }
    return count.toString();
  }
}